import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import { USER_ACCOUNT_OFFERING_TYPES } from '../constants';

export const buildAccountCompaniesRequest = (accountId, name) =>
  `${getAdminApiUrl()}/v1/accounts/${accountId}/companies?limit=200&sort=name${
    name ? `&filter[name]=${encodeURIComponent(name)}` : ''
  }`;

export const buildProjectTypesRequest = (accountId) =>
  `${getAdminApiUrl()}/v1/accounts/${accountId}/project-types?limit=200`;

export const buildCreateAccountCompanyRequest = (accountId, companyData) => [
  `${getAdminApiUrl()}/v1/accounts/${accountId}/companies`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(companyData),
  },
];

export const buildGetAccountUsersRequest = ({
  accountId,
  search,
  includeAllMembers,
  searchByEmailsArray = false,
  fields,
  equalTextMatch = false,
}) => {
  let buildedGetAccountUsersUrl = `${getAdminApiUrl()}/v1/accounts/${accountId}/users?limit=200`;

  if (equalTextMatch) {
    buildedGetAccountUsersUrl = `${buildedGetAccountUsersUrl}&filterTextMatch=equals`;
  }

  if (search) {
    const encodedSearch = encodeURIComponent(search);

    buildedGetAccountUsersUrl = searchByEmailsArray
      ? `${buildedGetAccountUsersUrl}&filter[emails]=${encodedSearch}`
      : `${buildedGetAccountUsersUrl}&filter[email]=${encodedSearch}`;
  }

  if (includeAllMembers) {
    buildedGetAccountUsersUrl = `${buildedGetAccountUsersUrl}&filter[status]=not_invited,pending,disabled,active`;
  }

  if (fields) {
    buildedGetAccountUsersUrl = `${buildedGetAccountUsersUrl}&fields=${fields}`;
  }

  return buildedGetAccountUsersUrl;
};

export const buildAccountDataRequest = (accountId) =>
  `${getAdminApiUrl()}/v1/accounts/${accountId}`;

export const buildGetAccountUserOfferingsRequest = (accountId, userId) =>
  `${getAdminApiUrl()}/v1/accounts/${accountId}/users/${userId}/offerings`;

export const getUserSubscriptionsProducts = (userOfferings) => {
  const userSubscriptions = userOfferings.filter(
    (offering) => offering.type !== USER_ACCOUNT_OFFERING_TYPES.NONE
  );
  return userSubscriptions.reduce((result, subscription) => {
    const { products: subscriptionProducts } = subscription;

    subscriptionProducts.forEach((product) => {
      if (
        product.included &&
        (product.userAssignable || product.type === PRODUCT_IDS.INSIGHT) &&
        !result.some((r) => r.type === product.type)
      )
        result.push(product);
    });

    return result;
  }, []);
};
